// Leitura/escrita tolerante de JSON no localStorage/sessionStorage.
//
// Motivação (bug de produção, tela de login em branco): `JSON.stringify(undefined)`
// devolve `undefined` (o valor, não uma string). `storage.setItem(k, undefined)`
// converte isso para a string literal `"undefined"`, que na leitura seguinte faz
// `JSON.parse` lançar `SyntaxError: "undefined" is not valid JSON`.
//
// Em `styles/global.js` esse parse roda no escopo de módulo — durante o import,
// fora de qualquer error boundary — então a exceção derruba o bundle inteiro e a
// tela fica branca. Pior: o valor envenenado persiste no navegador do usuário, de
// modo que corrigir a origem no backend não recupera quem já tem o registro ruim.
//
// `safeGet` trata qualquer conteúdo inválido como ausência de dado e remove a
// chave corrompida, permitindo que o fluxo normal a repopule.

// Descarta a chave corrompida para que o fluxo normal a repopule com um valor
// válido. Sem isso o registro ruim sobrevive a qualquer correção de backend.
function discard(storage, key) {
  try {
    storage.removeItem(key);
  } catch {
    // storage indisponível (modo privado / cookies bloqueados) — segue com null.
  }
  return null;
}

export function safeGet(storage, key) {
  let raw;
  try {
    raw = storage.getItem(key);
  } catch {
    return null;
  }

  if (raw === null || raw === '') return null;
  if (raw === 'undefined' || raw === 'NaN') return discard(storage, key);

  try {
    return JSON.parse(raw);
  } catch {
    return discard(storage, key);
  }
}

// Só persiste valores serializáveis. `undefined` nunca é gravado — é exatamente
// o que produzia a string "undefined" que quebrava o portal.
export function safeSet(storage, key, value) {
  if (value === undefined) return false;
  try {
    const raw = JSON.stringify(value);
    if (raw === undefined) return false;
    storage.setItem(key, raw);
    return true;
  } catch {
    return false;
  }
}
